export default __webpack_public_path__ + "static/media/text.11c61a52.md";